import HTTP from '@/plugins/axios';

export const getCountries = async(params: any) => {
  const response = await HTTP.get('/jobnews/languages', {
    params,
  });
  return response.data;
};
